module.exports = __webpack_public_path__ + "static/media/photoActualite.14c4634a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoActualite.jpg
// module id = 66
// module chunks = 0